import { useState, useEffect } from "react";
import axios from "axios";
import HeaderTools from "../../../../Components/ComponentsIndustry/HeaderTools";
import SubHeaderPurchase from "../../../../Components/ComponentsIndustry/SubHeaderPurchase";
import ProviderCard from "../../../../Components/ComponentsIndustry/ProviderCard";
import FooterButton from "../../../../Components/ComponentsIndustry/FooterButton";
import CountFooter from "../../../../Components/ComponentsIndustry/CountFooter";
import { Supplier } from "../../../../Supplier/Supplier";
import { useRawMaterial } from "../../../../providers/RawMaterialContext";
import { useValue } from "../../../../providers/ValueContext";

import { Container, SizeContainer, TitleContent } from "./style";
import { useUser } from "../../../../providers/UserContext";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const ToolsPurchaseChickenLight = () => {
  const { insumoFrangoLeve, setInsumoFrangoLeve, getStockInsumo } = useRawMaterial();
  const history = useHistory()
  const {
    outputValue,
    setOutputValue,
    outputValueThirty,
    setOutputValueThirty,
    outputValueSixty,
    setOutputValueSixty,
    entranceValue
  } = useValue();

  let [idProvider, setIdProvider] = useState(0)

  let [providerA, setProviderA] = useState(false);
  let [inCashA, setInCashA] = useState(false);
  let [thirtyDaysA, setThirtyDaysA] = useState(false);
  let [totalA, setTotalA] = useState(0);
  let [amountA, setAmountA] = useState(0);

  const [message, setMessage] = useState('')

  let [providerB, setProviderB] = useState(false);
  let [inCashB, setInCashB] = useState(false);
  let [thirtyDaysB, setThirtyDaysB] = useState(false);
  let [sixtyDaysB, setSixtyDaysB] = useState(false);
  let [totalB, setTotalB] = useState(0);
  let [amountB, setAmountB] = useState(0);

  const [sales, setSales] = useState(0);
  const [prodPlanning, setProdPlanning] = useState(0);
  const { user, rodada, industry, jogo } = useUser()

  function pagamento(data) {

    if (entranceValue > Number(data.total)) {
      axios.post("https://sistemas.sisinfor.com.br/BusinessGameBack/api/compra/cadastrar", data)
        .then(response => {
          if (response.data?.sucesso) {
            alert("Compra efetuada!")
            axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/estoqueInsumo/obterEstoqueIndustria/9/${industry?.industria}`)
              .then(responseEstoque => {
                var dateUpdated = insumoFrangoLeve
                dateUpdated.estoqueInicial = responseEstoque.data?.quantidade
                setInsumoFrangoLeve(dateUpdated)
              })
          } else {
            alert("Compra não pôde ser efetuada. " + response.data?.mensagem)
          }

        })
        .catch(error => console.log(error))
      // history.push("/toolsPurchaseChickenHeavy")
    } else {
      alert("Saldo Insuficiente")
    }
  }

  const handlePay = () => {

    const data = {
      "fornecedor": {
        "fornecedor": idProvider
      },
      "industria": industry,
      "insumo": {
        "insumo": 9,
      },
      "pagamento": "",
      "preco": 0,
      "quantidade": 0,
      "rodada": rodada,
      "total": 0
    }

    if (providerA === true) {
      data.quantidade = parseFloat(amountA) * Number(Supplier[1].frangoLeve.fornecedorA.confiabilidade.replace("%", "")) / 100;
      data.preco = 4.65;
      data.total = parseFloat(totalA);
      if (inCashA === true) {
        data.pagamento = "avista";
        pagamento(data)
        setOutputValue(outputValue + totalA);
      } else {
        data.pagamento = "30dias";
        pagamento(data)
        setOutputValueThirty(outputValueThirty + (totalA + (totalA * 5) / 100));
      }
    }

    if (providerB === true) {
      data.quantidade = amountB * Number(Supplier[1].frangoLeve.fornecedorB.confiabilidade.replace("%", "")) / 100;
      data.preco = 4.65;
      data.total = totalB;
      if (inCashB === true) {
        data.pagamento = "avista";
        pagamento(data)
        setOutputValue(outputValue + (totalB + (totalB * 2) / 100));
      } else if (thirtyDaysB === true) {
        data.pagamento = "30dias";
        pagamento(data)
        setOutputValueThirty(outputValueThirty + (totalB + (totalB * 5) / 100));
      } else {
        data.pagamento = "60dias";
        pagamento(data)
        setOutputValueSixty(outputValueSixty + (totalB + (totalB * 10) / 100));
      }
    }

    setInsumoFrangoLeve({
      estoqueInicial: insumoFrangoLeve.estoqueInicial,
      precoMedio: insumoFrangoLeve.precoMedio,
      cobertura: insumoFrangoLeve.cobertura,
      totalCompra: totalA + totalB,
      prevVenda: insumoFrangoLeve.prevVenda,
      quantidadeCompra: parseFloat(amountA) + parseFloat(amountB),
    });
  };

  useEffect(() => {
    if (user && rodada) {

      getStockInsumo()

      axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/pcp/obterInsumo/${9}/${industry?.industria}/${rodada.rodada}`)
        .then(response => {
          // const data = response.data[0]

          setInsumoFrangoLeve({
            estoqueInicial: insumoFrangoLeve.estoqueInicial,
            precoMedio: insumoFrangoLeve.precoMedio,
            cobertura: insumoFrangoLeve.cobertura,
            totalCompra: insumoFrangoLeve.totalCompra,
            prevVenda: insumoFrangoLeve.prevVenda,
            prevProducao: response.data.producao ? response.data.producao : 0,
            quantidadeCompra: insumoFrangoLeve.quantidadeCompra,
          })

        })

    }

  }, [setInsumoFrangoLeve, user, rodada])

  return (
    <Container>
      <SizeContainer>
        <HeaderTools
          pathImg="./images/purchase_button.svg"
          title="Compras"
          subTitle="(Insumos e Fornecedores)"
          style={["", "selection", "", "", ""]}
        />
        <SubHeaderPurchase
          style={["", "selection", "", "", "", "", ""]}
          product="Frango Vivo Leve"
          initialStock={insumoFrangoLeve.estoqueInicial}
          averagePrice={insumoFrangoLeve.estoqueInicial * insumoFrangoLeve.precoMedio}
          productionPlanning={insumoFrangoLeve.prevProducao}
          roof={insumoFrangoLeve.cobertura}
          sales={sales}
          setSales={setSales}
          prodPlanning={insumoFrangoLeve.prevProducao}
          setProdPlanning={setProdPlanning}
          setMessage={setMessage}
        />

        <TitleContent>
          <img src="./images/marketplace.svg" alt="marketplace" />
          Fornecedores de <span>Frango Leve</span>
        </TitleContent>

        <ProviderCard
          setIdProvider={setIdProvider}
          Supplier={Supplier[1].frangoLeve}
          title1="Fornecedor A"
          minQuant1={Supplier[1].frangoLeve.fornecedorA.minQuant}
          precoBase1={Supplier[1].frangoLeve.fornecedorA.precoBase}
          leadTime1={Supplier[1].frangoLeve.fornecedorA.leadTime}
          atraso1={Supplier[1].frangoLeve.fornecedorA.atraso}
          confiabilidade1={Supplier[1].frangoLeve.fornecedorA.confiabilidade}
          desconto1={Supplier[1].frangoLeve.fornecedorA.desconto}
          provider1={providerA}
          setProvider1={setProviderA}
          inCash1={inCashA}
          setInCash1={setInCashA}
          thirtyDays1={thirtyDaysA}
          setThirtyDays1={setThirtyDaysA}
          total1={totalA}
          setTotal1={setTotalA}
          amount1={amountA}
          setAmount1={setAmountA}
          title2="Fornecedor B"
          minQuant2={Supplier[1].frangoLeve.fornecedorB.minQuant}
          precoBase2={Supplier[1].frangoLeve.fornecedorB.precoBase}
          leadTime2={Supplier[1].frangoLeve.fornecedorB.leadTime}
          atraso2={Supplier[1].frangoLeve.fornecedorB.atraso}
          confiabilidade2={Supplier[1].frangoLeve.fornecedorB.confiabilidade}
          desconto2={Supplier[1].frangoLeve.fornecedorB.desconto}
          provider2={providerB}
          setProvider2={setProviderB}
          inCash2={inCashB}
          setInCash2={setInCashB}
          thirtyDays2={thirtyDaysB}
          setThirtyDays2={setThirtyDaysB}
          sixtyDays2={sixtyDaysB}
          setSixtyDays2={setSixtyDaysB}
          total2={totalB}
          setTotal2={setTotalB}
          amount2={amountB}
          setAmount2={setAmountB}
          title3={null}
          minQuant3={null}
          precoBase3={null}
          leadTime3={null}
          atraso3={null}
          confiabilidade3={null}
          desconto3={null}
          provider3={null}
          setProvider3={null}
          inCash3={null}
          setInCash3={null}
          thirtyDays3={null}
          setThirtyDays3={null}
          sixtyDays3={null}
          setSixtyDays3={null}
          total3={null}
          setTotal3={null}
          amount3={null}
          setAmount3={null}
        />
        <CountFooter total={totalA + totalB} />
        <FooterButton
          text="Confirmar"
          onHandle={handlePay}
        />
      </SizeContainer>
    </Container>
  );
};
export default ToolsPurchaseChickenLight;
